import React, { Component } from 'react';
import Select from 'react-select';
import request from 'superagent';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';

export default class ClioDocumentCategorySelector extends Component {
  static defaultProps = {
    connectionId: null,
    onChange: null,
  };

  static propTypes = {
    connectionId: PropTypes.number.isRequired,
    onChange: PropTypes.func,
  };

  state = {
    isLoading: false,
    isRefreshing: false,
  };

  async componentDidMount() {
    this.loadDocumentCategories(false);
  }

  render() {
    const { isLoading, isRefreshing, documentCategoryOptions } = this.state;

    if (isLoading && !documentCategoryOptions) return (
      <ProgressBar now={100} />
    );

    const refreshClasses = classNames({
      'fa': true,
      'fa-refresh': true,
      'fa-spin': isRefreshing
    });

    return (
      <div key="self" style={{ position: 'relative' }}>
        <Select
          defaultOptions
          options={documentCategoryOptions}
          isClearable
          simpleValue
          disabled={isLoading}
          { ... this.props }
        />
        <i className={refreshClasses}
          style={{
           position: 'absolute',
           textAlign: 'center',
           top: '12px',
           right: '27px',
           zIndex: 100,
           cursor: 'pointer',
          }}
          onClick={() => { !isRefreshing && this.loadDocumentCategories(true) }}
          key="doc-category-refresh-button"
        />
      </div>
    );
  }

  async loadDocumentCategories(refreshFromClio) {
    this.setState({
      isLoading: true,
      isRefreshing: refreshFromClio
    });

    const { connectionId } = this.props;

    const res = await request
      .get(`/rpc/integrations/connections/${connectionId}/clio/document-categories`)
      .query({ refresh: refreshFromClio });

    const documentCategoryOptions =  res.body.values.map(val => ({ label: val.name, value: val.id }));

    this.setState({
      isLoading: false,
      isRefreshing: false,
      documentCategoryOptions,
    });
  }
};

/*
  You can create Final Form compatible field via
  ```
    <Field
      name="documentCateogoryId"
      connectionId={connectionId}
      component={FinalFormCLioDocumentCategorySelector}
    />
  ```
*/
export const FinalFormClioDocumentCategorySelector = ({ input: { value, onChange }, ...rest }) => {
  return (
    <ClioDocumentCategorySelector
      value={value}
      onChange={selectedOption => onChange(selectedOption)}
      {...rest}
    />
  );
};



// WEBPACK FOOTER //
// ./src/Integrations/connections/ClioDocumentCategorySelector.jsx